module.exports = __webpack_public_path__ + "static/img/02bg2.e450299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/report/02week/02bg2.png
// module id = 4Sqs
// module chunks = 0